// export const initialState = {
//   isAuthenticated: false,
//   session: null,
//   userAttributes: null,
//   loading: true,
//   errorMessage: null,
//   newPasswordRequired: false,
//   user: null,
//   activePath: typeof window !== "undefined" ? window.location.pathname : "/",
//   mfaRequired: false,
//   userGroup: null,
// };

export const initialState = {
  activePath: typeof window !== "undefined" ? window.location.pathname : "/",
  userAttributes: null,
  userGroup: null,
};

export const AuthReducer = (state, action) => {
  switch (action.type) {
    case "SIGN_OUT":
      return initialState; // Reset state to initial values
    case "NAVIGATE": {
      return {
        ...state,
        activePath: action.payload,
      };
    }
    case "SET_USER_ROLES": {
      return {
        ...state,
        userGroup: action.payload,
      };
    }
    case "SET_USER_ATTRIBUTES": {
      return { 
        ...state, 
        userAttributes: action.payload 
      };
    }
    default:
      throw new Error(`Unhandled action type: ${action.type}`);
  }
};
